import { Box } from '@mui/material';
import { SKELETON_ITEMS_COUNT } from '../consts';
import { LiveTopicsPanelItemSkeleton } from './LiveTopicsPanelItemSkeleton';

/**
 * Skeleton for the Live Topics list loading state.
 * Renders a set of list item skeletons with dividers to mimic the topic list.
 */
export function LiveTopicsListSkeleton() {
  return (
    <Box>
      {Array.from({ length: SKELETON_ITEMS_COUNT }).map((_, i) => (
        <LiveTopicsPanelItemSkeleton key={i} />
      ))}
    </Box>
  );
}
